module.exports = __webpack_public_path__ + "img/success-icon.c50c6d45.png";